import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';
import { observer } from 'mobx-react-lite';
import { BrowserRouter as Router } from 'react-router-dom';
import { store, StoreContext, useStore } from './stores/store';
import { ReportRoutesWithHeader, ReportRoutesWithoutHeader } from './ReportRoutes';
import ModalContainer from './components/ModalContainer';
import './app.css';


interface Props {
  userId: number
  departmentId: number
  holderTypeId: number
  hospitalId: number
  landingZoneUrl: string
  isRemote: boolean
  redisCache: {}
  redisKey?: string
  // isUserInRole: (roleName: string) => boolean
}

const App = ({
  isRemote,
  userId,
  departmentId,
  holderTypeId,
  hospitalId,
  landingZoneUrl,
  redisKey,
  redisCache,
  // isUserInRole,
}: Props) => {
  const { commonStore } = useStore();
  commonStore.setIsRemote(isRemote);
  commonStore.setDepartmentId(departmentId);
  commonStore.setUserId(userId);
  commonStore.setHospitalId(hospitalId);
  commonStore.setLandingZoneUrl(landingZoneUrl);
  commonStore.setHolderTypeId(holderTypeId);
  //commonStore.setIsUserInRole(isUserInRole);
  commonStore.setRedisCache(redisCache);

  if (redisKey) commonStore.setRedisKey(redisKey);

  useEffect(() => {
    commonStore.setRedisCache(redisCache);
  }, [redisCache]);


  const ReportContainers = () => {
    return (
      <>
        <ToastContainer position='top-right' hideProgressBar />
        <ModalContainer />
      </>
    );
  };

  return isRemote ? (
    <>
      <StoreContext.Provider value={store}>
        <ReportContainers />
        <ReportRoutesWithoutHeader />
      </StoreContext.Provider>
    </>
  ) : (
    <>
      <StoreContext.Provider value={store}>
        <ReportContainers />
        <Router>
          <ReportRoutesWithHeader />
        </Router>
      </StoreContext.Provider>
    </>
  );
};

export default observer(App);


